import React,{useState} from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBaby, faHome,faMobile,faEnvelope } from '@fortawesome/free-solid-svg-icons';
import {faDumbbell,faHeadphones,faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis } from 'recharts';

function Profile(props) {
  const data = [
    {subject:'의사소통', A:120, fullMark:150},
    {subject:'문제해결', A:130, fullMark:150},
    {subject:'협업', A:110, fullMark:150},
    {subject:'기술력', A:90, fullMark:150},
    {subject:'창의성', A:130, fullMark:150},
    {subject:'책임감', A:115, fullMark:150},
  ]

  const [flip, setFlip] = useState(false);

  const handleClick = () =>{
    setFlip(!flip);
  };

  return (

    <section className='profile' id='Profile'>
      <h2>Profile</h2>
      
      <div className='profile_img' onClick={handleClick}>
        <div className={`flipper ${flip ? 'flip' : ''}`} >
          <img src={`${process.env.PUBLIC_URL}/images/illustration.png`} className='front' alt='일러스트 이미지' />
          <img src={`${process.env.PUBLIC_URL}/images/profile.png`} className='back' alt='프로필이미지'/>
        </div>
      </div>
      
        <div className='profile_text'>
          <div className='profile_name'>최화빈</div>
          <p><FontAwesomeIcon icon={faBaby}/>1998 10 21</p>
          <p><FontAwesomeIcon icon={faHome}/>부천시 소사구 거주</p>
          <p><FontAwesomeIcon icon={faMobile}/>010 8251 2301</p>
          <p><FontAwesomeIcon icon={faEnvelope}/>chlghkqls123@naver.com</p>

          <p>
            <span># <FontAwesomeIcon icon={faDumbbell}/>운동</span>
            <span className='music'>
              <Link to='https://www.melon.com/mymusic/playlist/mymusicplaylistview_inform.htm?plylstSeq=547174055'># <FontAwesomeIcon icon={faHeadphones}/>노래</Link>
            </span>
            <span># <FontAwesomeIcon icon={faMagnifyingGlass}/>맛집</span>
            </p>
        </div>

      <article className='profile_r'>
        <h3>Skill</h3>
        <ul className='skill'>
          <li>
            <img src={`${process.env.PUBLIC_URL}/images/html.png`} alt='html로고'/>
          </li>
          <li>
            <img src={`${process.env.PUBLIC_URL}/images/css.png`} alt='css로고'/>
          </li>
          <li>
            <img src={`${process.env.PUBLIC_URL}/images/js.png`} alt='js로고'/>
          </li>
          <li>
            <img src={`${process.env.PUBLIC_URL}/images/react.png`} alt='react로고'/>
          </li>
          <li>
            <img src={`${process.env.PUBLIC_URL}/images/php.png`} alt='php로고'/>
          </li>
          <li>
            <img src={`${process.env.PUBLIC_URL}/images/git.png`} alt='git로고'/>
          </li>
        </ul>
        
        <h3>Education</h3>
        <ul className='education'>
          <li>2025 그린컴퓨터학원 『프로젝트기반』프론트엔드 개발자 양성(Figma/React/Next.js/PHP/Mysql/chatGPT) 이수</li>
          <li>2023~2024 삼성반도체 가스장비 감리 및 유지보수</li>
          <li>2023 가톨릭관동대학교 호텔경영학과 졸업</li>
          <li>2021~2022 nest 호텔 F&B 근무</li>
          <li>2017 심원고등학교 졸업</li>
        </ul>

        <div className='about'>
          <h3>About Me</h3>
          <div>
            <p>사용의 <span>편리함</span>을 넘어서, 눈이 <span>즐거운 경험</span>을 만드는 프론트엔드 개발자 최화빈입니다.</p>
          </div>
        </div>
        
        <div className='data'>
          <RadarChart cx={300} cy={300} outerRadius={160} width={500} height={500} data={data}>
            <PolarGrid />
            <PolarAngleAxis dataKey="subject" tick={{ fill: '#fff', fontSize: 14, fontWeight: 600 }}/>
            <PolarRadiusAxis angle={30} domain={[0, 150]} />
            <Radar name="능력치" dataKey="A" stroke="none" fill="#fff" fillOpacity={0.6} />
          </RadarChart>
        </div>
      </article>
    </section>
  );
}

export default Profile;